import * as React from 'react';
import { Body2 } from '@cian/ui-kit';
import { IconToggleStarOn16 } from '@cian/ui-kit-design-tokens/icons';

import * as style from './Rating.css';

export interface IRatingProps {
  rating: number;
  countText: string;
}

const HIGH_RATING_THRESHOLD = 4;

export const Rating = ({ rating, countText }: IRatingProps): React.JSX.Element => {
  const color = rating >= HIGH_RATING_THRESHOLD ? 'decorative-orange' : 'text-secondary-default';

  return (
    <div className={style['container']}>
      <IconToggleStarOn16 color={color} />
      <Body2 color={color}>{rating.toFixed(1).replace('.', ',')}</Body2>
      <Body2 color="text-secondary-default">{countText}</Body2>
    </div>
  );
};
